import { TechnicalSkillsList } from "./components/technicalSkillsList";
import { FormComponent } from "./components/formModelOne";
import React, { Component } from "react";
// import DataFilter from "react-data-filter";
import { Button, Form, Modal, Divider, Table, Input, Tag,List,Card,Typography ,  Avatar,
  Icon,
  Progress, } from "antd";
import { connect } from "react-redux";
import uuid from "uuid/v4";
import * as loginActions from "./actions";
import "./projects.css";
import { Link } from "react-router-dom";
import "./view.css";
import GenTable from "./genTable";

const { Paragraph } = Typography;
const { Search } = Input;
const { Meta } = Card;

class Projects extends Component {
  constructor(props) {
    super(props);
    // 
    // 
    this.state = {
      visible: false,
      loading: false,
      showOther: false,
      filterDropdownVisible: false,
      data: [],
      searchvalue:'',
      modelTitle:'',
      modal2Visible: false,
    };
  }

  onInputChange = e => {
    this.setState({ searchText: e.target.value });
    this.onSearch();
  };
  onSearch = name => () => {
    const { searchText } = this.state;
    const reg = new RegExp(searchText, "gi");
    this.setState({
      filterDropdownVisible: false,
      data: this.props.projects.data
        .map(record => {
          const match = record[name].match(reg);
          if (!match) {
            return null;
          }
          return {
            ...record,
            [name]: (
              <span>
                {record[name]
                  .split(reg)
                  .map((text, i) =>
                    i > 0
                      ? [<span className="highlight">{match[0]}</span>, text]
                      : text
                  )}
              </span>
            )
          };
        })
        .filter(record => !!record)
    });
  };

  showModal = () => {
    this.props.modelFromStep(true, false, 3);
  };

  handleCancel = () => {
    this.props.modelFromStep(false, false, 3);
  };

  editSkillHandler = index => e => {
    this.props.modelFromStep(true, false, 3, index);
  };
  deleteProjectHandler = index => {
    this.props.deleteItem(
      this.props.profile.projectsDoneList[index],
      "projectsDoneList",
      "projectID"
    );
  };

  componentWillUnmount() {
    this.props.onUnload();
  }

  //WARNING! To be deprecated in React v17. Use componentDidMount instead.
  componentWillMount() {
    this.props.loadProjectsList();
  }

  setModal2Visible(modal2Visible,modelTitle) {
    this.setState({ modal2Visible,modelTitle:modelTitle });
  }

  render() {
    // 
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 24 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 24 }
      }
    };

    let { teams } = this.props.profile;
    const { showOther } = this.state;
    if (typeof teams == "undefined") {
      teams = [];
    }

    const { form } = this.props;
    const { getFieldDecorator, validateFields } = form;
    const isEdit = this.props.itemIndex !== null;
    const onValidateForm = itemData => e => {
      e.preventDefault();
      validateFields((err, values) => {
        if (!err) {
          if (itemData) {
            values.projectID = itemData.projectID;
          } else {
            values.projectID = uuid();
          }
          // 
          // 
          this.props.stepFourSubmit(
            values,
            "projectsDoneList",
            "projectID",
            this.props.itemIndex
          );
        }
      });
    };

    // 
    // 
    return (
      <div className="container" style={{ marginTop: 50 }}>
        <h2 className="steponeHeading" style={{marginBottom:30}}>Teams </h2>
        <Modal
          title={this.state.modelTitle}
          centered
          width='90%'
          bodyStyle={{paddingTop:5}}
          visible={this.state.modal2Visible}
          footer={null}
          onCancel={() => this.setModal2Visible(false,this.state.modelTitle)}
        >
         <GenTable
               props={this.props}
                data={
                 []
                }
    
              />
        </Modal>

{/* 
        <Table
          columns={columns}
          dataSource={this.props.projects.data ? this.props.projects.data : []}
        /> */}
        <Search
          placeholder="Search in table"
          enterButton="Search"
          size="large"
          allowClear 
          style={{marginBottom:30}}
          onSearch={value => this.setState({searchvalue:value})}
        />
    <List
    loading={this.props.teams && this.props.teams.valid ?  !this.props.teams.valid : true}
    grid={{ gutter: 16, column: 3 }}
    pagination={{pageSize:30}}
    dataSource={this.props.teams.data ? this.props.teams.data.filter(data=> Object.keys(data).filter(key => ((data[key]).toString().toUpperCase()).includes((this.state.searchvalue).toUpperCase())).length > 0 ? true: false) : []}
    renderItem={item => (
      <List.Item>
        <Card style={{height:'140px !important'}}
        actions={[
          <div onClick={() => this.setModal2Visible(true,item.teamName)}><Icon type="line-chart" key="setting" /> View Team Analytics</div>
        ]}
        >
                <Meta
                  avatar={
                    <Avatar src="https://icon-library.net/images/team-icon-png/team-icon-png-28.jpg" />
                  }
                  title={item.teamName}
                />
               
                <div
                  style={{
                    marginTop: 10
                  }}
                >
                Team Description :  <Paragraph ellipsis={{ rows: 2, expandable: true, onExpand:(a)=>{} }}>{item.teamDiscription}{" "}</Paragraph>
                </div>

                <div
                  style={{
                    marginTop: 2
                  }}
                >
                  <Icon type="team" />
                  Team Size: {item.teamSize}{" "}
                </div>
                <div
                  style={{
                    marginTop: 2
                  }}
                >
                  <Icon type="user" />
                  Created by :  <Link to={`/home/profile/${item.createdBy.UID}`}>
            {item.createdBy.displayName}
          </Link>
                </div>
              </Card>
      </List.Item>
    )}
  />

      </div>
    );
  }
}

const mapStateToProps = state => {
  // 
  // 
  return {
    auth: state.firebase.auth,
    step: state.auth.step,
    visible: state.auth,
    profile: state.firebase.profile,
    itemIndex: state.auth.itemIndex,
    teams: state.auth.teams
  };
};

const mapDispachToProps = (dispatch, props) => ({
  stepFourSubmit: (formValue, categary, arrayField, itemIndex = null) => {
    dispatch(
      loginActions.stepWithSkillsSubmit(
        formValue,
        props.history,
        categary,
        3,
        arrayField,
        itemIndex
      )
    );
  },
  modelFromStep: (visible, loading, step, itemIndex = null) => {
    dispatch(loginActions.modelFromStep(visible, loading, step, itemIndex));
  },
  deleteItem: (val, category, arrayField) => {
    dispatch(loginActions.deleteItem(val, category, arrayField));
  },
  loadProjectsList: () => {
    dispatch(loginActions.loadProjectsList());
  },
  onUnload: () =>
    dispatch({ type: "HOME_PAGE_UNLOADED" })
});

export default connect(
  mapStateToProps,
  mapDispachToProps
)(Form.create()(Projects));
